module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/remove-click-delay-fastclick-282.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/development/remove-click-delay-fastclick.md
// module id = 725
// module chunks = 406